<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<!--  Баблы внутренних табов  -->
<div class="bubble-container head">
    <button [class.selected]="tab === 0"
            (click)="tab = 0"
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.MAIN' | translate }}
    </button>
    <button [class.selected]="tab === 1"
            (click)="tab = 1"
            disabled
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.STATISTICS' | translate }}
    </button>
    <button [class.selected]="tab === 2"
            (click)="tab = 2"
            disabled
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.HISTORY' | translate }}
    </button>
</div>

@switch (tab) {
    @case (0) {
        <div class="table-container">

            <!--    Статистика по всем кошелькам    -->
            <div class="widget-container column-3">
                @if (mainFinanceStatistic) {
                    <div class="widget-header">
                        <h2>{{ 'INDEX_PAGE.FINANCE.WIDGET_HEADERS.STATISTICS' | translate }}</h2>
                        <i class="ri-refresh-line"
                           (click)="getMainFinanceStatistic()"
                        ></i>
                    </div>
                    <div class="widget-body finance-statistic">
                        <h1>{{ mainFinanceStatistic.total | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}</h1>
                        <span>
                        <i class="ri-arrow-right-up-box-fill green"></i>
                            {{ mainFinanceStatistic.in || 0 | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </span>
                        <span>
                        <i class="ri-arrow-left-down-box-fill blue"></i>
                            {{ mainFinanceStatistic.out || 0 | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </span>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>

            <!--    Все кошельки    -->
            <div class="widget-container column-3">
                @if (allWallets) {
                    <div class="widget-header">
                        <h2>{{ 'INDEX_PAGE.FINANCE.WIDGET_HEADERS.WALLETS' | translate }}</h2>
                        <i class="ri-refresh-line"
                           (click)="getAllProjectWallets()"
                        ></i>
                    </div>
                    <div class="widget-body">
                        <div class="bubble-container">
                            <button [class.selected]="allWallets.currentTab === 'allSingleContractWallets'"
                                    (click)="allWallets.currentTab = 'allSingleContractWallets'"
                            >
                                {{ 'INDEX_PAGE.FINANCE.BUBBLES_TEXT.CONTRACTS' | translate }}
                            </button>
                            <button [class.selected]="allWallets.currentTab === 'allMultiplyContractWallets'"
                                    (click)="allWallets.currentTab = 'allMultiplyContractWallets'"
                            >
                                {{ 'INDEX_PAGE.FINANCE.BUBBLES_TEXT.MULTI' | translate }}
                            </button>
                            <button [class.selected]="allWallets.currentTab === 'allWalletsWithoutContracts'"
                                    (click)="allWallets.currentTab = 'allWalletsWithoutContracts'"
                            >
                                {{ 'INDEX_PAGE.FINANCE.BUBBLES_TEXT.PERSONAL' | translate }}
                            </button>
                        </div>
                        <section class="wallets-table">
                            <table mat-table
                                   [dataSource]="allWallets[allWallets.currentTab]"
                            >
                                <!-- Title Column -->
                                <ng-container matColumnDef="title">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        {{ 'INDEX_PAGE.FINANCE.TEXT.TITLE' | translate }}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        {{ element.title }}
                                    </td>
                                </ng-container>

                                <!-- Total Column -->
                                <ng-container matColumnDef="total">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        {{ 'INDEX_PAGE.FINANCE.TEXT.BALANCE' | translate }}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        {{ element.total | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                                    </td>
                                </ng-container>


                                <tr mat-header-row
                                    *matHeaderRowDef="['title', 'total']; sticky: true"
                                ></tr>
                                <tr mat-row
                                    *matRowDef="let row; columns: ['title', 'total'];"
                                ></tr>
                                <tr class="mat-row"
                                    *matNoDataRow
                                >
                                    <td class="mat-sell"
                                        colspan="2"
                                    >
                                        <strong>{{ 'EMPTY_LISTS.WALLETS' | translate }}</strong>
                                    </td>
                                </tr>
                            </table>
                        </section>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>

            <!--    Курсы валют    -->
            <div class="widget-container column-2">
                <div class="widget-header">
                    <h2>{{ 'INDEX_PAGE.FINANCE.WIDGET_HEADERS.EXCHANGE' | translate }}</h2>
                    <!--                <i class="ri-refresh-line"></i>-->
                </div>
                <div class="widget-body exchange-table">
                    <div class="light">
                        <span>{{ 'INDEX_PAGE.FINANCE.TEXT.EXCHANGE.DOLLAR' | translate }} </span><span>70,73</span>
                    </div>
                    <div>
                        <span>{{ 'INDEX_PAGE.FINANCE.TEXT.EXCHANGE.EURO' | translate }}</span><span>92,60</span>
                    </div>
                    <div class="light">
                        <span>{{ 'INDEX_PAGE.FINANCE.TEXT.EXCHANGE.YUAN' | translate }}</span><span>11,28</span>
                    </div>
                    <div>
                        <span>{{ 'INDEX_PAGE.FINANCE.TEXT.EXCHANGE.RUPEE' | translate }}</span><span>91,02</span>
                    </div>
                    <div class="light">
                        <span>{{ 'INDEX_PAGE.FINANCE.TEXT.EXCHANGE.LIRA' | translate }}</span><span>80,73</span>
                    </div>
                    <div>
                        <span>{{ 'INDEX_PAGE.FINANCE.TEXT.EXCHANGE.DIRHAM' | translate }}</span><span>21,98</span>
                    </div>
                </div>
            </div>

            <!--    Кнопки банковских продуктов    -->
            <div class="widget-container mini-ads column-2">
                <h2>Инвестиции</h2>
                <section>
                    <img src="assets/images/ads/invest.png" alt="#" width="101" height="87">
                </section>
            </div>

            <div class="widget-container mini-ads column-2">
                <h2>Драгоценные металлы</h2>
                <section>
                    <img src="assets/images/ads/gold.png" alt="#" width="121" height="67">
                </section>
            </div>

            <div class="widget-container mini-ads column-2">
                <h2>Вклады</h2>
                <section>
                    <img src="assets/images/ads/safe.png" alt="#" width="101" height="67">
                </section>
            </div>

            <div class="widget-container mini-ads column-2">
                <h2>Кредитование</h2>
                <section>
                    <img src="assets/images/ads/calc.png" alt="#" width="80" height="77">
                </section>
            </div>
            <!--  Кнопки END  -->

            <!--    Блок с рекламой кредита    -->
            <div class="widget-container column-8" style="margin-top:15px">
                <div class="widget-body row-ads">
                    <div>
                        <div style="display: flex; align-items: center;">
                            <span>{{ 'INDEX_PAGE.FINANCE.TEXT.ADS.TITLE' | translate }}</span>
                            <span class="big">3 950 000 ₽</span>
                        </div>
                        <small class="light">{{ 'INDEX_PAGE.FINANCE.TEXT.ADS.DAY' | translate }}</small>
                    </div>
                    <div class="main-ads">
                        <div style="margin-right: 30px;">
                            <span>240 220 ₽</span><br>
                            <small class="light">{{ 'INDEX_PAGE.FINANCE.TEXT.ADS.PAY' | translate }}</small>
                        </div>
                        <div class="middle">
                            <span>{{ 'INDEX_PAGE.FINANCE.TEXT.ADS.PERCENT' | translate }}</span><br>
                            <small class="light">{{ 'INDEX_PAGE.FINANCE.TEXT.ADS.RATE' | translate }}</small>
                        </div>
                        <div style="margin-left: 30px;">
                            <span>0%</span><br>
                            <small class="light">{{ 'INDEX_PAGE.FINANCE.TEXT.ADS.COMMISSION' | translate }}</small>
                        </div>
                    </div>
                    <div>
                        <button class="button blue">
                            <i class="ri-wallet-2-fill"></i>
                            {{ 'INDEX_PAGE.FINANCE.TEXT.ADS.SEND' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!--    Транзакции    -->
            <div class="widget-container column-4">
                @if (allPayments) {
                    <div class="widget-header">
                        <h2>{{ 'INDEX_PAGE.FINANCE.WIDGET_HEADERS.PAYMENTS' | translate }}</h2>
                        <i class="ri-refresh-line"
                           (click)="getAllPaymentsHistory()"
                        ></i>
                    </div>
                    <div class="widget-body">
                        <div class="bubble-container">
                            <button [class.selected]="allPayments.currentTab === 'allPayments'"
                                    (click)="allPayments.currentTab = 'allPayments'"
                            >
                                {{ 'INDEX_PAGE.BUBBLES_TEXT.ALL' | translate }}
                            </button>
                            <button [class.selected]="allPayments.currentTab === 'incomingPayments'"
                                    (click)="allPayments.currentTab = 'incomingPayments'"
                            >
                                {{ 'INDEX_PAGE.BUBBLES_TEXT.INCOMING' | translate }}
                            </button>
                            <button [class.selected]="allPayments.currentTab === 'outcomingPayments'"
                                    (click)="allPayments.currentTab = 'outcomingPayments'"
                            >
                                {{ 'INDEX_PAGE.BUBBLES_TEXT.OUTCOMING' | translate }}
                            </button>
                        </div>

                        <section class="transaction-table">
                            <table mat-table
                                   [dataSource]="allPayments[allPayments.currentTab]"
                            >
                                <!-- payer_type Column -->
                                <ng-container matColumnDef="payer_type">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        {{ 'INDEX_PAGE.FINANCE.TEXT.PAYER_TYPE' | translate }}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        {{ element.payer_type }}
                                    </td>
                                </ng-container>

                                <!-- payment_status Column -->
                                <ng-container matColumnDef="payment_status">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        {{ 'INDEX_PAGE.FINANCE.TEXT.STATUS' | translate }}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        {{ element.payment_status }}
                                    </td>
                                </ng-container>

                                <!-- total Column -->
                                <ng-container matColumnDef="total">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        {{ 'INDEX_PAGE.FINANCE.TEXT.SUM' | translate }}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        {{ element.total | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                                    </td>
                                </ng-container>

                                <!-- created_at Column -->
                                <ng-container matColumnDef="created_at">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        {{ 'INDEX_PAGE.FINANCE.TEXT.TIME' | translate }}
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                    <span> {{ element.created_at | date:'dd.MM.yy' }}
                                        <span class="dt__time">
                                            {{ element.created_at | date:'HH:mm' }}
                                        </span>
                                    </span>
                                    </td>
                                </ng-container>

                                <tr mat-header-row
                                    *matHeaderRowDef="['payer_type', 'payment_status', 'total', 'created_at'], sticky: true"
                                ></tr>
                                <tr mat-row
                                    *matRowDef="let row; columns: ['payer_type', 'payment_status', 'total', 'created_at'];"
                                ></tr>
                                <tr class="mat-row"
                                    *matNoDataRow
                                >
                                    <td class="mat-sell"
                                        colspan="4">
                                        <strong>
                                            {{ 'EMPTY_LISTS.PAYMENTS' | translate }}
                                        </strong>
                                    </td>
                                </tr>

                            </table>
                        </section>

                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>

            <!--    Календарь    -->
            <div class="widget-container column-4">
                <!--                @if (allPayments) {-->
                <div class="widget-header">
                    <h2>{{ 'INDEX_PAGE.FINANCE.WIDGET_HEADERS.CALENDAR' | translate }}</h2>
                    <i class="ri-more-2-line"></i>
                </div>
                <div class="widget-body calendar-widget">
                    <app-calendar
                            [monthDate]="current"
                            [items]="itemsMap"
                            [calendarLegend]="calendarLegend"
                            [maxItemsPerCell]="3"
                            [disableNextMonth]="true"
                            (monthChange)="getPaymentsForCalendar($event[0], $event[1])"
                            (dayClick)="onDayClick($event)"
                            (itemClick)="onItemClick($event)"
                    >
                    </app-calendar>
                </div>
                <!--                } @else {-->
                <!--                    <ng-container *ngTemplateOutlet="loading"></ng-container>-->
                <!--                }-->
            </div>
        </div>
    }
    @case (1) {
        Тут статистика
    }
    @case (2) {
        тут история
    }
}
